import GoogleSSO from 'components/auth/Google';
import Auth0SSO from 'components/auth/Auth0';
import Title from 'components/layout/Title';

export default function SignIn() {
  return (
    <div className='w-full max-w-xs mx-auto'>
      <Title className='text-center'>Espace Médecin</Title>
      <div className='flex flex-col items-center space-y-6'>
        <Auth0SSO />
        <GoogleSSO />
      </div>
    </div>
  );
}
